import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    height: 120px;
    display: flex;  // Configuração flex para alinhar horizontalmente
    border-bottom: 1px solid rgb(0, 107, 219);
`;

export const TextArea = styled.div`
    flex: 1;  // Permite que a área do texto cresça conforme necessário
    h1 {
        padding: 30px 0 5px 30px;
        color: rgb(0, 107, 219);
    }
    p {
        padding: 5px 0 10px 40px;
    }
`;

export const ImageArea = styled.div`
    width: 120px;  // Largura fixa para a imagem
    img {
        width: 100%;  // A imagem preenche totalmente a largura de sua área
        height: auto;  // Altura automática para manter a proporção
    }
`;
